
/* NOTIFICATION */
export const GET_NOTIFICATION_LISTING = "GET_NOTIFICATION_LISTING";
export const GET_NOTIFICATION_LISTING_SUCCESS = "GET_NOTIFICATION_LISTING_SUCCESS";
export const GET_NOTIFICATION_LISTING_FAIL = "GET_NOTIFICATION_LISTING_FAIL";

export const GET_NOTIFICATION_DETAILS = "GET_NOTIFICATION_DETAILS";
export const GET_NOTIFICATION_DETAILS_SUCCESS = "GET_NOTIFICATION_DETAILS_SUCCESS";
export const GET_NOTIFICATION_DETAILS_FAIL = "GET_NOTIFICATION_DETAILS_FAIL";

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const ADD_NOTIFICATION_SUCCESS = "ADD_NOTIFICATION_SUCCESS";
export const ADD_NOTIFICATION_FAIL = "ADD_NOTIFICATION_FAIL";

export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAIL = "UPDATE_NOTIFICATION_FAIL";

export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCCESS";
export const DELETE_NOTIFICATION_FAIL = "DELETE_NOTIFICATION_FAIL";

export const EXPORT_NOTIFICATION = "EXPORT_NOTIFICATION";
export const EXPORT_NOTIFICATION_SUCCESS = "EXPORT_NOTIFICATION_SUCCESS";
export const EXPORT_NOTIFICATION_FAIL = "EXPORT_NOTIFICATION_FAIL";

export const RESET_NOTIFICATION_STATE = 'RESET_NOTIFICATION_STATE';
export const RESET_NOTIFICATION_ACTION_STATE = 'RESET_NOTIFICATION_ACTION_STATE';

export const READ_NOTIFICATION = "READ_NOTIFICATION";
export const READ_NOTIFICATION_SUCCESS = "READ_NOTIFICATION_SUCCESS";
export const READ_NOTIFICATION_FAIL = "READ_NOTIFICATION_FAIL";

export const READ_ALL_NOTIFICATION = "READ_ALL_NOTIFICATION";
export const READ_ALL_NOTIFICATION_SUCCESS = "READ_ALL_NOTIFICATION_SUCCESS";
export const READ_ALL_NOTIFICATION_FAIL = "READ_ALL_NOTIFICATION_FAIL";